export const GET_PROFILE_FOR_CURRENT_USER = "GET_PROFILE_FOR_CURRENT_USER";
export const GOT_PROFILE_FOR_CURRENT_USER = "GOT_PROFILE_FOR_CURRENT_USER";
export const GET_CUSTOMERS_BASED_ON_FILTER = "GET_CUSTOMERS_BASED_ON_FILTER";
export const GOT_CUSTOMERS_BASED_ON_FILTER = "GOT_CUSTOMERS_BASED_ON_FILTER";
export const GET_STAFF_SERVICES_AND_MORE = "GET_STAFF_SERVICES_AND_MORE";
export const GOT_STAFF_SERVICES_AND_MORE = "GOT_STAFF_SERVICES_AND_MORE";
export const GET_SERVICE_RESOURCE_AVAILABILITY_DATES =
  "GET_SERVICE_RESOURCE_AVAILABILITY_DATES";
export const GOT_SERVICE_RESOURCE_AVAILABILITY_DATES =
  "GOT_SERVICE_RESOURCE_AVAILABILITY_DATES";
export const ERROR_SERVICE_RESOURCE_AVAILABILITY_DATES =
  "ERROR_SERVICE_RESOURCE_AVAILABILITY_DATES";
export const GET_SERVICE_RESOURCE_AVAILABILITY_TIMES =
  "GET_SERVICE_RESOURCE_AVAILABILITY_TIMES";
export const GOT_SERVICE_RESOURCE_AVAILABILITY_TIMES =
  "GOT_SERVICE_RESOURCE_AVAILABILITY_TIMES";
export const ERROR_SERVICE_RESOURCE_AVAILABILITY_TIMES =
  "ERROR_SERVICE_RESOURCE_AVAILABILITY_TIMES";

export const UPDATE_WAITLIST_STEP_DATA = "UPDATE_WAITLIST_STEP_DATA";

export const SAVE_WAITLIST = "SAVE_WAITLIST";
export const SAVE_WAITLIST_ERROR = "SAVE_WAITLIST_ERROR";
export const SAVED_WAITLIST = "SAVED_WAITLIST";

export function loadCachedProfileForCurrentUser(cachedData) {
  return {
    type: GOT_PROFILE_FOR_CURRENT_USER,
    data: cachedData,
  };
}

export const getServiceResourceAvailabilityDates = (
  serviceId,
  resourceId,
  day
) => {
  return {
    type: GET_SERVICE_RESOURCE_AVAILABILITY_DATES,
    data: {
      serviceId,
      resourceId,
      day,
    },
  };
};

export const gotServiceResourceAvailabilityDates = ({ payload, data }) => ({
  type: GOT_SERVICE_RESOURCE_AVAILABILITY_DATES,
  payload,
  data,
});

export const getStaffServicesAndMore = () => {
  return {
    type: GET_STAFF_SERVICES_AND_MORE,
  };
};

export const getCustomersBasedOnFilter = (filter) => {
  return {
    type: GET_CUSTOMERS_BASED_ON_FILTER,
    filter,
  };
};

export const loadCachedProviderDetails = (cachedData) => {
  return {
    type: GOT_STAFF_SERVICES_AND_MORE,
    data: cachedData,
  };
};

export const updateWaitlistStepData = (data) => {
  return {
    type: UPDATE_WAITLIST_STEP_DATA,
    data,
  };
};

export const saveWaitlist = (waitlistStepData, cb) => {
  return {
    type: SAVE_WAITLIST,
    data: { waitlistStepData, cb },
  };
};
